import React from 'react';
import './Technology.css'; // Mise à jour du fichier CSS

const Technology = () => {
  return (
    <div className="technology-technology">
      <div className="content-technology">
        <h2>Technologies</h2>
        <p>Nous accompagnons les entreprises dans l'intégration de solutions technologiques innovantes en automatisation, contrôle industriel et systèmes électriques intelligents, favorisant la performance et la digitalisation des processus.</p>
      </div>
    </div>
  );
};

export default Technology;